export default __webpack_public_path__ + "static/media/zm.e73e007f.svg";